import React from 'react'
import { useMemo } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import Select, { components } from 'react-select';
import AdminMaster from '../../../Layout/admin/Master';
import {  CREATE_NPI_AND_TIN, EDIT_NPI_AND_TIN } from '../../../routeNames';
import { changeAllTitleFunction, downloadFile } from '../Dashboard/functions';
import { Tooltip } from '@mui/material';
import queueDatatableCustomStyles from '../../../Layout/Elements/QueueDatatableCustomStyles';
import { enableOrDisableNpiTin, exportNpiAndTinList, getNpiAndTinList } from '../../../Redux/npiandtin/action';
import { PiExportBold } from 'react-icons/pi';
import { useRowLoaders } from '../../../hooks/dataTableRowLoader';
import useCommonAlert from '../../../hooks/useCommonAlert';
import CommonSwal from '../../CommonSwal';
import useFilter from '../../../hooks/useFilter';
import FilterComponent from '../../common/FilterComponent';
import PartnerDropDown from '../../common/PartnerClientFacilityDropDown/PartnerDropDown';
import ClientDropDown from '../../common/PartnerClientFacilityDropDown/ClientDropDown';
import FacilityDropDown from '../../common/PartnerClientFacilityDropDown/FacilityDropDown';
import LogModal from './components/LogModal';
import ImportNpiTinModal from './components/ImportNpiTinModal';
import { BsClockHistory } from "react-icons/bs";
import { useLogModal } from '../../../hooks/useLogModal';
import CustomeLogModal from '../../common/CustomeLogModal';
import { getNpiTinLogs } from '../../../Redux/sftpClient/action';
import { BiHistory } from 'react-icons/bi';

const NPIAndTIN = () => {

    const { setLoading: rowLoader, isRowLoading, clearLoading,loadingRows } = useRowLoaders();
    const {showCustomeSwal,isSwalCommon,hideCustomeSwal} = useCommonAlert()
    const [state, setState] = useState({
        error: false,
        error_message: "",
        showToast: false,
    });
    const [toaster, setToaster] = useState(false)
    const [filterText, setFilterText] = useState('');
    const [colorRow, setColorRow] = React.useState({});
    const [selectedRows, setSelectedRows] = useState([]);
    const [exportLoading, setExportLoading] = useState(false);
    const [importModalRow, setImportModalRow] = useState(null);
    // Define initial filter values
    const initialFilters = {
        clients: [],
        facility: [],
        partner: [],
        is_active:""
    };

    const {
        isOpen,
        logData,
        loading:loadingLog,
        totalRows:totalRowsLog,
        limit:limitLog,
        colorRow:colorRowLog,
        openModal,
        closeModal,
        handlePageChange:handlePageChangeLog,
        handlePerRowsChange:handlePerRowsChangeLog,
        handleRowClick:handleRowClickLog,
        handleChangeFilter,
        userSelectlist,
        filterData,
    } = useLogModal(getNpiTinLogs);


    // Use the custom hook
    const {
        data,
        setData,
        loading,
        pageNo,
        limit,
        totalRows,
        reRenderDataTable,
        searchFormik,
        handlePageChange,
        handlePerRowsChange,
        handleReset,
        fetchData:fetchNpiAndTin
    } = useFilter(initialFilters, getNpiAndTinList);

    useEffect(() => {
        fetchNpiAndTin(1, limit)
    }, []);

    const __toggleNpiTin = (id) => {
        rowLoader(id)
        enableOrDisableNpiTin(id)((response) => {
            if (response?.status && response?.status_code === 201) {
                setState({ showToast: !state.showToast })
                setData(prevData => ({
                    ...prevData,
                    results: prevData?.results?.map(item =>
                        item?.id === id
                          ? { ...item, is_active: !item.is_active }
                          : item
                      )
                  }));
                setToaster('success')
                clearLoading(id)
            } else {
                clearLoading(id)
                showCustomeSwal({
                    row: null,
                    show: true,
                    title: "Error",
                    type: 'error',
                    message: response?.response?.data?.message,
                    onConfirm: () => {
                        hideCustomeSwal();
                    },
                    confirmBtnText:"Ok",
                    showCancel:false,
                    showConfirm:true,
                })
                setState({ error: true, error_message: response?.message });
            }
        });
    }

    useEffect(() => {
        if (toaster) {
            const timer = setTimeout(() => {
                setToaster(false)
            }, 2000);
            return () => clearTimeout(timer)
        }
    }, [toaster])

    const handleRowClick = (row) => {
        setColorRow(row);
    };

    const handleRowCheckClick = (row) => {
        data?.results.map((item, index) => {
            if (row?.id == item.id) {
                setColorRow(row)
            }
        })
    };

    const handleRowSelected = React.useCallback((selected) => {
        setSelectedRows(selected?.selectedRows || []);
    }, []);

    const handleExport = () => {
        setExportLoading(true);
        const ids = selectedRows?.length > 0 ? selectedRows.map(row => row.id).join(',') : "";
        exportNpiAndTinList(searchFormik?.values, ids)((response) => {
            if (response?.status && response?.file_url) {
                downloadFile(response?.file_url, `NPI-TIN`, true);
            }
            setExportLoading(false);
        });
    };

    const checkUserPermission = (check) => {
        var permissions = JSON.parse(localStorage.getItem('permissions'))
        var data = permissions.find((element) => {
            return element == check;
        })
        if (data && data != undefined) {
            return true;
        }
        else {

            return false;
        }
    }
    var i = 0;
    const conditionalRowStyles = [

        {
            when: row => { i = i + 1; return i % 2 == 0 || colorRow.id == row.id ? true : false },
            style: (row, index) => ({
                backgroundColor: colorRow?.id == row.id ? '#dbf4f5' : '#f2f2f2',
            }),
        },
    ];


      const handleOpenLog = (pk) => {
        setSelectedRowsModal(pk)
        
      setLogModalopen(true)
    }


    const columns = useMemo(
        () => [
            {
                id: 'id',
                name: 'S.NO',
                selector: (row, index) => pageNo == 1 ? index + 1 : (pageNo - 1) * limit + index + 1,
                sortable: true,
                width: '50px',
                //sortable: true,

            },
            {
                id: 'client',
                name: 'client',
                selector: row => row?.client,
                cell: (row) => <div>
                    {row?.client &&

                        <div className='d-flex flex-row  flex-wrap text-truncate' onClick={() => handleRowClick(row)} style={{ width: '260px' }}>
                            <Tooltip disableInteractive title={row?.client} placement='top' arrow>
                                {row?.client &&
                                    <span className='text-truncate ' onDoubleClick={() => handleDblClickCopy(row?.client)}>{row?.client}</span>
                                }
                            </Tooltip>
                        </div>
                    }
                </div>,
                sortable: true,
            },
            
            {
                id: 'facility',
                name: 'Facility',
                selector: row => row?.facility,
                cell: (row) => <div>
                    {row?.facility &&
                        <div className='d-flex flex-row flex-wrap text-truncate' onClick={() => handleRowClick(row)} style={{ width: '400px' }}>
                            <Tooltip disableInteractive title={row?.facility} placement='top' arrow>
                                {row?.facility &&
                                    <span className='text-truncate' >{row?.facility}</span>
                                }
                            </Tooltip>
                        </div>

                    }

                </div>,
                sortable: true,
            },
            {
                id: 'partner',
                name: 'Partner',
                selector: row => row?.partner,
                cell: (row) => <div>
                    {row?.partner &&

                        <div className='d-flex flex-row  flex-wrap text-truncate' onClick={() => handleRowClick(row)} style={{ width: '260px' }}>
                            <Tooltip disableInteractive title={row?.partner} placement='top' arrow>
                                {row?.partner &&
                                    <span className='text-truncate ' onDoubleClick={() => handleDblClickCopy(row?.partner)}>{row?.partner}</span>
                                }
                            </Tooltip>
                        </div>
                    }
                </div>,
                sortable: true,
            },
            {
                id: 'actions',
                name: 'Actions',
                cell: (row) =>
                    <div className='d-flex align-items-center gap-2' onClick={() => handleRowClick(row)}>
                        <React.Fragment>
                            {checkUserPermission('edit_npi_and_tin') &&

                                <Tooltip disableInteractive title="Edit" placement='top' arrow>
                                    <Link onClick={() => changeAllTitleFunction('Edit NPI & TIN', `${EDIT_NPI_AND_TIN}${row.id}`)} className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1" >
                                        <span className="svg-icon svg-icon-3">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path opacity="0.3" d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z" fill="currentColor"></path>
                                                <path d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z" fill="currentColor"></path>
                                            </svg>
                                        </span>
                                    </Link>
                                </Tooltip>
                            }
                            {checkUserPermission('enable_npi_and_tin') &&

                                        !isRowLoading(row.id) ?
                                                <div className="ms-2" >
                                                    <Tooltip disableInteractive title="Status" placement='top' arrow>
                                                        <Form.Check
                                                            onClick={() => __toggleNpiTin(row.id)}
                                                            type="switch"
                                                            role="switch" defaultChecked={row.is_active} id="flexSwitchCheckDefault"
                                                        />
                                                    </Tooltip>
                                                </div>
                                                :
                                                <div className="me-2" >
                                                    <div className="spinner-border spinner-border-sm " role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                </div>
                                        
                            }

                            <>
                            <Tooltip disableInteractive title="Npi & Tin Log" placement="top" arrow>
                                <Link
                                    className="d-flex align-items-center"
                                    style={{ fontSize: '1.5em', height: '32px' }}
                                    onClick={() => openModal(row?.id)}
                                >
                                      <BiHistory className='icon-style' />
                                </Link>
                            </Tooltip>
                            </>

                            {checkUserPermission('edit_npi_and_tin') &&
                                <Tooltip disableInteractive title="Import NPI & TIN" placement="top" arrow>
                                    <Link
                                        className="d-flex align-items-center"
                                        style={{ fontSize: '1.5em', height: '32px' }}
                                        onClick={() => setImportModalRow(row)}
                                    >
                                        <i className='bi bi-upload icon-style'></i>
                                    </Link>
                                </Tooltip>
                            }
                        </React.Fragment>

                    </div>,
                //sortable: true,
                ignoreRowClick: false,
                allowOverflow: true,
                right: true,
                button: false,
                //width: "100px",

            },



        ],
        [pageNo,loadingRows,data],
    );
    
    const status_list = [{ value: "true", label: "Active" }, { value: "false", label: "Inactive" }]

    return (
        <React.Fragment>
            <AdminMaster ToastMessage={toaster} />
            <main id="main" className="main">
            <CommonSwal
                isSwalCommon={isSwalCommon}
            />
                <div className="pagetitle tab-fixed-header">
                    <h1 id='page-title'>NPI & TIN</h1>
                </div>

                <section className="section mt-5 ">
                    <div className="row align-items-top py-2 gap-2 gap-md-5">
                        <div className="col-lg-12">
                            <div className="card mb-5 mb-xl-8 ">
                                <FilterComponent
                                    formik={searchFormik}
                                    onReset={handleReset}
                                    showExportButton={false}
                                    extraAction={
                                        <Tooltip disableInteractive title="Export" placement='top' arrow>
                                            <Button
                                                className="btn btn-light btn-active-primary"
                                                type="button"
                                                disabled={exportLoading}
                                                onClick={handleExport}
                                            >
                                                <span className="svg-icon svg-icon-3">
                                                    {exportLoading ?
                                                        <div className="spinner-border spinner-border-sm" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                        :
                                                        <PiExportBold />
                                                    }
                                                </span>
                                            </Button>
                                        </Tooltip>
                                    }
                                >
                                    {/* Your specific filter fields */}
                                    <PartnerDropDown lockboxformik={searchFormik} />
                                    <ClientDropDown lockboxformik={searchFormik} />
                                    <FacilityDropDown lockboxformik={searchFormik} />
                                    <div>
                                        <Select
                                            options={status_list}
                                            className="select-search-client"
                                            classNamePrefix="select"
                                            placeholder="Select Status"
                                            menuPlacement="auto"
                                            maxMenuHeight={300}
                                            isClearable
                                            name="is_active"
                                            onChange={(e) => { searchFormik.setFieldValue("is_active", e?.value || "") }}
                                            styles={{
                                                control: styles => ({ ...styles, backgroundColor: "hsl(204deg 33.33% 97.06%)", borderStyle: "none", boxShadow: "none", borderRadius: "10px" }), placeholder: styles => ({
                                                    ...styles,
                                                }), indicatorSeparator: styles => ({ ...styles, width: "0px", minHeight: "20px" }), container: styles => ({ ...styles, borderRadius: "9px" })
                                            }}
                                        />
                                    </div>
                                </FilterComponent>

                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="dashboardtable">
                                            {!reRenderDataTable &&
                                                <DataTable
                                                    className="custom-datatable"
                                                    fixedHeader={true}
                                                    data={data?.results}
                                                    columns={columns}
                                                    progressPending={loading}
                                                    pagination
                                                    paginationServer
                                                    highlightOnHover
                                                    selectableRows
                                                    selectableRowsHighlight
                                                    onSelectedRowsChange={handleRowSelected}
                                                    paginationTotalRows={totalRows}
                                                    paginationPerPage={limit}
                                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                                    onChangeRowsPerPage={handlePerRowsChange}
                                                    onChangePage={handlePageChange}
                                                    conditionalRowStyles={conditionalRowStyles}
                                                    onRowClicked={handleRowCheckClick}
                                                    theme="solarized"
                                                    customStyles={queueDatatableCustomStyles}

                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <ImportNpiTinModal
                    show={!!importModalRow}
                    row={importModalRow}
                    onClose={() => setImportModalRow(null)}
                    onImported={() => {
                        fetchNpiAndTin(pageNo, limit ,searchFormik?.values);
                        setToaster('success');
                    }}
                />

                <CustomeLogModal
                    filterData={filterData}
                    userSelectlist={userSelectlist}
                    handleChangeFilter={handleChangeFilter}
                    show={isOpen}
                    onClose={closeModal}
                    logData={logData}
                    loading={loadingLog}
                    totalRows={totalRowsLog}
                    limit={limitLog}
                    onPageChange={handlePageChangeLog}
                    onRowsPerPageChange={handlePerRowsChangeLog}
                    onRowClick={handleRowClickLog}
                    colorRow={colorRowLog}
                    title="Npi & Tin Logs"
                />
            </main>
        </React.Fragment>
    )
}

export default NPIAndTIN